export type IsIn = {
  arguments: string[];
  key: string;
  operator: 'in';
};

export const isIn = function (values: string[], possibilities: string[]): boolean {
  return values.some((value) => possibilities.includes(value));
};
